export const buildSlideKey = (slideId: number | string) =>
  `${slideId}`;

export const getSlideItemDataId = (slide: { itemData?: any; id?: any }): number | string | undefined => {
  const slideData = slide.itemData;
  return slideData?.SlideID ?? slideData?.Slide?.ID ?? slideData?.ID ?? slide.id;
};

export const markAlreadyAddedSlides = <T extends { itemData?: any; id?: any; selectable?: boolean }>(
  slides: T[],
  addedSlideKeys: Set<string> | undefined,
): T[] => {
  if (!addedSlideKeys) return slides;

  return slides.map((slide) => {
    const slideId = getSlideItemDataId(slide);
    return slideId != null && addedSlideKeys.has(buildSlideKey(slideId)) ? { ...slide, selectable: false } : slide;
  });
};
